import { getIconSrc } from "@components/Icon/utils/helpers";
import { CommonClassNameAndTestId } from "@typings/Common";

import { IconTypeEnum } from "./utils/types";

export type IconImgProps = {
  /** Icon name */
  icon: IconTypeEnum;
  /** Size of the icon */
  iconSize: number;
  /** Alt text for the icon */
  imgAlt?: string;
} & CommonClassNameAndTestId;

/**
 * IconImg component is used to display an icon image.
 * @param {IconImgProps} props - The component props.
 * @param {IconTypeEnum} props.icon - The icon name.
 * @param {number} props.iconSize - The size of the icon.
 * @param {string} [props.imgAlt] - The alt text for the icon.
 * @returns {React.ReactElement} - The rendered component.
 */
export default function IconImg({
  testId,
  icon,
  iconSize,
  imgAlt = "",
  className,
}: IconImgProps): React.ReactElement {
  return (
    <img
      src={getIconSrc(icon)}
      width={iconSize}
      height={iconSize}
      alt={imgAlt}
      className={className}
      data-testid={testId}
    />
  );
}
